import {Grid, Row, Col} from '@/grid';
import Container from '@/container';
import Link from '@/links';
import {H1, P} from '@/typography';
import {withHomeSubP} from '@/hocs/withFontType';
import {withMarginBottomZeroToLg, withMarginTopZeroToMd} from '@/hocs/withSpacing';
import {withNeutral800, withGreen800} from '@/hocs/withColors';
import {useTranslations} from 'next-intl';
import styles from './styles.module.scss';

const HeroWrapperMobile = withMarginTopZeroToMd('div');
const H1Green800 = withGreen800(H1);
const SubPNeutral800 = withNeutral800(withHomeSubP(P));
const CtaDefaultMarginedMob = withMarginBottomZeroToLg(Link);

const HeroSection = () => {
  const t = useTranslations('pricing.heroSection');
  const shared = useTranslations('shared');

  return (
    <HeroWrapperMobile>
      <Container variant="section-padding-below-nav">
        <Grid fluid>
          <Row center="xs">
            <Col xs={12} lg={9}>
              <H1Green800>{t('title')}</H1Green800>
              <SubPNeutral800>{t('subtitle')}</SubPNeutral800>
            </Col>
          </Row>
          <Row center="xs">
            <Col xs={12} lg={6}>
              <ul className={styles['list-inline-to-bl']}>
                <li>
                  <CtaDefaultMarginedMob
                    href="/free-trial"
                    variant="cta-default-xs"
                    customAttributes={{
                      'data-gtm': 'pricing-hero-free-trial',
                      'data-ui': 'pricing-hero-free-trial'
                    }}>
                    {shared('freeTrialCTALabel')}
                  </CtaDefaultMarginedMob>
                </li>
                <li>
                  <Link
                    href="/demo"
                    variant="primary"
                    customAttributes={{
                      'data-gtm': 'pricing-hero-demo',
                      'data-ui': 'pricing-hero-demo'
                    }}>
                    {shared('demoCTALabel')}
                  </Link>
                </li>
              </ul>
            </Col>
          </Row>
        </Grid>
      </Container>
    </HeroWrapperMobile>
  );
};

export default HeroSection;
